export default "__VITE_ASSET__4JwctfLE__"